<template>
  <div class="d-flex" v-if="endereco">
    <div>
      <div class="social-button mr-2" :class="classEndereco">
        <label :class="{ active: activeEndereco }">&nbsp;</label>
      </div>
    </div>
    <div class="text-endereco">
      <div v-if="sem_endereco">Sem endereço físico</div>
      <div v-else-if="!sem_endereco && endereco.internacional">
        {{ endereco.pais.nome }}<br />
        {{ endereco.internacional_descricao }}
      </div>
      <div v-else>
        {{ endereco.logradouro }}
        {{ endereco.numero ? ", " + endereco.numero : "" }}<br />
        {{ endereco.bairro }} <br />
        <span v-if="endereco.cidade">
          {{ endereco.cidade.nome }} /
          {{ endereco.cidade.estado_sigla }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    endereco: {
      type: [Object, null],
      required: true,
      default: null,
    },
    sem_endereco: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tipoEndereco() {
      let tipoEndereco = "";

      if (this.sem_endereco) {
        tipoEndereco = "sem-endereco";
      } else if (!this.sem_endereco && this.endereco.internacional) {
        tipoEndereco = "onu";
      } else {
        tipoEndereco = "brasil";
      }

      return tipoEndereco;
    },
    classEndereco() {
      return this.tipoEndereco + "-icon";
    },
    activeEndereco() {
      if (this.tipoEndereco == "brasil" && !this.endereco.cidade) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
.text-endereco {
  font-size: 0.8em;
  line-height: 0.9rem;
}
</style>
